module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_pp12_9006.180723b2.png";